function get_realtime_payload(dom_event) {
  const payload = dom_event?.detail;
  if (!payload || typeof payload !== "object") return null;
  return payload;
}

function get_realtime_event_type(payload) {
  return payload?.event_type || payload?.type || null;
}

function normalize_id(value) {
  if (value === null || value === undefined) return null;
  return String(value);
}

function is_notification_management_payload(payload) {
  return payload?.module === "notification_management";
}

function get_current_user_id(view_model) {
  return normalize_id(view_model?.user_id || view_model?.user_details?.user_id);
}

function get_payload_user_id(payload) {
  return normalize_id(
    payload?.data?.notification?.user_id ||
    payload?.data?.user_id ||
    payload?.user_id
  );
}

function notification_targets_current_user(payload, view_model) {
  const payload_user_id = get_payload_user_id(payload);
  const current_user_id = get_current_user_id(view_model);

  if (!payload_user_id || !current_user_id) return false;
  return payload_user_id === current_user_id;
}

function sync_unread_count(view_model, payload) {
  const unread_count = payload?.data?.unread_count;
  if (unread_count === null || unread_count === undefined) return;

  const parsed_count = Number(unread_count);
  if (!Number.isNaN(parsed_count)) {
    view_model.unreadCount = parsed_count;
  }
}

const NOTIFICATION_FIELDS = [
  "id",
  "message",
  "date",
  "user_id",
  "is_read",
  "redirect_url",
];

const NOTIFICATION_DEFAULTS = {
  id: null,
  message: "",
  date: null,
  user_id: null,
  is_read: false,
  redirect_url: null,
};

function normalize_notification_field(key, value) {
  if (key === "is_read") return Boolean(value);
  return value ?? Reflect.get(NOTIFICATION_DEFAULTS, key);
}

function sanitize_notification(notification) {
  if (!notification || typeof notification !== "object") return null;

  const safe_notification = {};
  NOTIFICATION_FIELDS.forEach((key) => {
    const raw_value = Reflect.get(notification, key);
    Reflect.set(
      safe_notification,
      key,
      normalize_notification_field(key, raw_value)
    );
  });

  return safe_notification;
}

function merge_notifications(existing_notification, incoming_notification) {
  const merged_notification = {};

  NOTIFICATION_FIELDS.forEach((key) => {
    const existing_value = Reflect.get(existing_notification || {}, key);
    const incoming_value = Reflect.get(incoming_notification || {}, key);
    Reflect.set(merged_notification, key, incoming_value ?? existing_value ?? null);
  });

  return merged_notification;
}

function upsert_notification(view_model, notification) {
  if (!notification) return false;
  if (!Array.isArray(view_model?.notifications)) return false;

  const safe_notification = sanitize_notification(notification);
  if (!safe_notification) return false;

  const notification_id = normalize_id(safe_notification?.id);
  if (!notification_id) return false;

  const existing_index = view_model.notifications.findIndex(
    (item) => normalize_id(item?.id) === notification_id
  );

  if (existing_index >= 0) {
    const existing_notification =
      sanitize_notification(Reflect.get(view_model.notifications, existing_index)) || {};
    view_model.notifications.splice(
      existing_index,
      1,
      merge_notifications(existing_notification, safe_notification)
    );
  } else {
    view_model.notifications.unshift(safe_notification);
  }

  return true;
}

function apply_notification_realtime(view_model, payload) {
  const notification = payload?.data?.notification;
  if (!notification) return;
  if (!notification_targets_current_user(payload, view_model)) return;

  const changed = upsert_notification(view_model, notification);
  sync_unread_count(view_model, payload);

  if (!changed && typeof view_model?.fetch_notifications === "function") {
    view_model.fetch_notifications();
  }
}

export function handle_notification_realtime(view_model, dom_event) {
  const payload = get_realtime_payload(dom_event);
  if (!payload) return;
  if (!is_notification_management_payload(payload)) return;

  const event_type = get_realtime_event_type(payload);
  if (event_type !== "notification") return;

  apply_notification_realtime(view_model, payload);
}
